import { render, staticRenderFns } from "./SideBarNav.vue?vue&type=template&id=78d9a11b&"
import script from "./SideBarNav.vue?vue&type=script&lang=ts&"
export * from "./SideBarNav.vue?vue&type=script&lang=ts&"
import style0 from "./SideBarNav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports